import { Box, Grid, Heading, Text, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import introVideo from '../../assets/videos/intro.mp4'
const CoursePage = () => {
  // const lectureNumber=0
const [lectureNumber, setLectureNumber] = useState(0)
  const lectures=[
    {
    _id:"sahil1",
    title:"React js in One Hour",
    description:"sample description1",
    video:{
      url:'sahil2'
    }
  },
    {
    _id:"sahil1",
    title:"React js in One Hour",
    description:"sample description2",
    video:{
      url:'sahil2'
    }
  },
    {
    _id:"sahil1",
    title:"React js in One Hour",
    description:"sample description3",
    video:{
      url:'sahil2'
    }
  },
    {
    _id:"sahil1",
    title:"React js in One Hour",
    description:"sample description4",
    video:{
      url:'sahil2'
    }
  },
    {
    _id:"sahil1",
    title:"React js in One Hour",
    description:"sample description5",
    video:{
      url:'sahil2'
    }
  },
]
  return (
    <Grid minH={'90vh'} templateColumns={['1fr','3fr 1fr']}>
        <Box>
        <video width={'100%'} autoPlay={true} controls controlsList='nodownload  noremoteplayback' disablePictureInPicture disableRemotePlayback src={introVideo}>

</video>
<Heading m='4' children={`#${lectureNumber+1} ${lectures[lectureNumber].title}`}></Heading>
<Heading m='4' children="Description"></Heading>
<Text m='4' children={lectures[lectureNumber].description}/>
        </Box>
        <VStack>
        {
          lectures.map((element,index)=>(
            <button onClick={()=>setLectureNumber(index)} key={element._id} style={{width:"100%",padding:"1rem",textAlign:'center', margin:0,borderBottom:'1px solid rgba(0,0,0,0.2)'}}>
              <Text >
                #{index+1} {element.title}
              </Text>
            </button>
          ))
        }
        </VStack>
    </Grid>
  )
}

export default CoursePage